import { configureStore } from "@reduxjs/toolkit";

import { useDispatch, useSelector } from "react-redux";
import companySlice from "./company-slice.tsx";
import templatesSlice from "./templates-slice.ts";
import userSlice from "./user-slice.tsx";

const store = configureStore({
  reducer: {
    company: companySlice.reducer,
    user: userSlice.reducer,
    templates: templatesSlice.reducer,
  },
});

export default store;

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;

export const useAppDispatch = useDispatch.withTypes<AppDispatch>();
export const useAppSelector = useSelector.withTypes<RootState>();
